import React, { useState, useEffect } from 'react';

import { apiPost, apiGet, getAccountsApiUrl, getAdminApiUrl, apiMessages } from '../common/AppApi';

import Processing from '../common/Processing';
import MessageTag from '../common/MessageTag';
import { StateArray, PrivilegeCodes, AccountTypeArray } from '../common/Constants';
import { patternMessage, invalidInputStyle, selectOptions } from '../common/Forms';
import { cleanPhone } from '../common/Formats';
import Strings from  '../common/Strings';
import useUserContext from '../common/UserContext';
import { Link } from 'react-router-dom';

export default function AdminTesting() {
	let [showSpinner, setSpinner] = useState(false);
	let [message, setMessage] = useState();

	let handleSubmit = (e) => {
		e.preventDefault();
		console.debug('submitted');
	};

	let addApplicationProgram = () => {
		setSpinner(true);
		let url = getAccountsApiUrl() + '/application/1/1';
		apiPost(url, {}).then( resp => {
			console.debug('all good');
			setMessage({text:'Application program added.', type:'success'});
		}).catch( error => {
			console.debug(error);
			if (error.status == 404) {
				setMessage({text:'Not found error occurred.', type:'danger'});
			} else {
				setMessage({text:'An error occurred.', type:'danger'});
			}
		}).finally( () => setSpinner(false));
	};

	return (
		<>
		<h3>Testing</h3>
		<Processing show={showSpinner} />
		<MessageTag message={message} />
		
		<form onSubmit={handleSubmit}>
			<button type='button' id='btnOne' className='btn btn-primary btn-sm' onClick={addApplicationProgram}>Test One</button>

		</form>

		</>
	);

}
